export default "__VITE_ASSET__CxsnPHuq__"